// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] + "-" + {"230":"f71e5521901545397210","256":"7b5b76d7e5a6e3291b7f","532":"393959f0fabdf080ab73"}[chunkId] + ".js";
};